/**
 * @generated SignedSource<<7be71694389900a36e120d8c37bcf205>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedUnpurchasableHeader_item$data = {
  readonly isSold: boolean | null;
  readonly title: string | null;
  readonly " $fragmentType": "PdpSharedUnpurchasableHeader_item";
};
export type PdpSharedUnpurchasableHeader_item$key = {
  readonly " $data"?: PdpSharedUnpurchasableHeader_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUnpurchasableHeader_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedUnpurchasableHeader_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "627b8bf25ace6cbfa2920b636eb56e4e";

export default node;
